export default "__VITE_ASSET__d2ff2068__"